import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import BigCard from "../../../general/BigCard";
import Leaflet from "./maps/LeafletMap";
import styles from "./ObraL2.module.css";
import { ObraStore } from "./ObraStore";

function ObraL2({ distrito }) {
  const [numeroPropriedades, setNumeroPropriedades] = useState(null);
  const [areaMedia, setAreaMedia] = useState(null);

  const gerenciaPropriedadeValue = ObraStore(
    (state) => state.gerenciaPropriedadeValue,
  );

  const maoDeObraValue = ObraStore((state) => state.maoDeObraValue);

  const organizacaoValue = ObraStore((state) => state.organizacaoValue);

  const setObraMapImage = ObraStore((state) => state.setObraMapImage);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [numeroPropriedades, areaMedia] = await Promise.all([
          Api.getNumeroPropriedadesObra(
            distrito,
            gerenciaPropriedadeValue,
            maoDeObraValue,
            organizacaoValue,
          ),
          Api.getAreaMediaDistritoObra(
            distrito,
            gerenciaPropriedadeValue,
            maoDeObraValue,
            organizacaoValue,
          ),
        ]);
        setNumeroPropriedades(numeroPropriedades);
        setAreaMedia(areaMedia);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [distrito, gerenciaPropriedadeValue, maoDeObraValue, organizacaoValue]);

  return (
    <div className={styles.obraL2}>
      <div className={styles.cards}>
        <div className={styles.card}>
          <BigCard name="Propriedades" value={numeroPropriedades?.value} />
        </div>
        <div className={styles.card}>
          <BigCard
            name={
              <>
                Área Média
                <br />
                (ha)
              </>
            }
            value={areaMedia?.value?.toFixed(2)}
          />
        </div>
      </div>

      <div className={styles.map}>
        <Leaflet distrito={distrito} onImageReady={setObraMapImage} />
      </div>
    </div>
  );
}

export default ObraL2;
